import { useTranslation } from '@unifyapps/i18n/client';
import CheckCircle from '@unifyapps/icons/outline/CheckCircle';
import { EmptyStateDeprecated as BaseEmptyStateDeprecated } from '@unifyapps/ui/components/EmptyStateDeprecated';
import { FeaturedIcon } from '@unifyapps/ui/components/FeaturedIcon';
import { useMemo } from 'react';

export function EmptyState() {
  const { t } = useTranslation(['notifications']);

  const icon = useMemo(() => <FeaturedIcon color="success" Icon={CheckCircle} size="lg" />, []);

  return (
    <BaseEmptyStateDeprecated
      description={t('notifications:EmptyState.description')}
      icon={icon}
      title={t('notifications:EmptyState.title')}
    />
  );
}
